import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/:id',
	components: () => [import(/* webpackChunkName: 'rentalRouteInfo' */ './component')],
	render: ([RouteInfo]) => <RouteInfo />,
};

export default routes;
